import { create } from 'zustand';

interface HeaderToolbarSlotState {
  element: HTMLElement | null;
  setElement: (element: HTMLElement | null) => void;
}

// DOM node in the app header that a page's Gantt toolbar portals into once it scrolls away.
export const useHeaderToolbarSlotStore = create<HeaderToolbarSlotState>((set) => ({
  element: null,
  setElement: (element) => set({ element }),
}));
